
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tedai2024",
      function () {
        return require("private-next-pages/tedai2024.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tedai2024"])
      });
    }
  